<template>
  <div>
    <b-modal
      id="confirmRemoveAiAccommodation"
      modal-class="modal-cover"
      v-model="isVisible"
      hide-backdrop
      hide-footer
      content-class="shadow-lg"
    >
      <section class="text-center" :dir="isHebrew ? 'rtl' : 'ltr'">
        <b-row>
          <b-col cols="12" class="py-2">
            <h3 class="font-weight-medium card-title">
              {{ t('aiChatConfirmRemoveAccommodationTitle') }}
            </h3>
            <p class="confirm-remove-accommodation__name">🏨 {{ name }}</p>
            <p class="confirm-remove-accommodation__note">
              {{ t('aiChatConfirmRemoveAccommodationNote') }}
            </p>
          </b-col>

          <b-col cols="12" class="py-2">
            <b-btn
              pill
              variant="danger"
              class="px-5 py-2 text-white"
              @click="confirmRemove"
              >{{ t('aiChatRemoveAccommodation') }}</b-btn
            >
            <b-btn
              pill
              variant="success"
              class="px-5 py-2 text-white"
              @click="closePopup"
              >{{ t('removeAttractionCancelButton') }}</b-btn
            >
          </b-col>
        </b-row>
      </section>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { translationMixin } from '@/mixins/translationMixin';

export default {
  props: ["value"],
  mixins: [translationMixin],

  computed: {
    ...mapGetters(['inerModalParameters']),
    name() {
      const params = this.inerModalParameters;
      return (params && params.name) || '';
    },
    isVisible: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    ...mapActions(['showModal']),
    confirmRemove() {
      // showModal('') clears inerModalParameters, so grab the callback first.
      const params = this.inerModalParameters;
      const onConfirm = params && params.onConfirm;
      this.showModal('');
      if (onConfirm) onConfirm();
    },
    closePopup() {
      this.showModal('');
    },
  },
};
</script>

<style scoped>
.modal.modal-cover .modal-content,
.modal.modal-cover .modal-footer,
.modal.modal-cover .modal-header {
  border: none;
}
.confirm-remove-accommodation__name {
  font-size: 16px;
  font-weight: 600;
  margin: 12px 0 4px;
}
.confirm-remove-accommodation__note {
  font-size: 14px;
  color: #a71d2a;
  margin: 0;
}
</style>
